module.exports = "https://cdn-assessment.mathletics.com/app/104/assets/images/f65da4a6cbb8daa615422ce7ee38d9b4.svg";